import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";

//DataTable
import { AttachmeneTableColumn } from "../../../Data/DataTables/CandidatesAttachments";

//TYPE
import { ViewApplicantAttachments } from "../../../Types/Applicants/ApplicantsAttachments";

//SERVICES
import {
  VIEW_APPLATTACHMENTS_QUERY_KEY,
  applicantAttachmentsService,
} from "../../../Services/applicantsattachmentService";

interface CandidateProfileProps {
  ApplNo: string;
}

const AttachmentsTable = ({ ApplNo }: CandidateProfileProps) => {
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const { data: attachmentData = [], isLoading: AttachmentisLoading } =
    useQuery<ViewApplicantAttachments[]>({
      queryKey: [...VIEW_APPLATTACHMENTS_QUERY_KEY, ApplNo],
      queryFn: () =>
        applicantAttachmentsService.viewByApplication(ApplNo as string),
    });

  const filteredItems: ViewApplicantAttachments[] = attachmentData.filter(
    (item) =>
      item.status === 1 &&
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={AttachmeneTableColumn}
          striped={true}
          pagination
          progressPending={AttachmentisLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default AttachmentsTable;
